'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _base = require('base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListBox = function (_BaseField) {
	_inherits(ListBox, _BaseField);

	function ListBox(props) {
		_classCallCheck(this, ListBox);

		return _possibleConstructorReturn(this, (ListBox.__proto__ || Object.getPrototypeOf(ListBox)).call(this, props));
	}

	_createClass(ListBox, [{
		key: 'options',
		value: function options() {
			return this.props.options || [];
		}
	}, {
		key: 'getOptionList',
		value: function getOptionList(options) {
			// Testing
			return (options || this.options()).map(function (opt, index) {
				return React.createElement(
					'option',
					{ key: opt.id, value: opt.id },
					opt.formattedvalue || opt.value
				);
			});
		}
	}, {
		key: 'additionalContent',
		value: function additionalContent() {
			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var options = this.options().slice();

			if (!options.length && this.props.hideWhenEmpty) {
				return null;
			}

			var selectedItem = this.getValue();

			var theSelectedOption;
			if (selectedItem) theSelectedOption = options.filter(function (item) {
				return selectedItem.id == item.id;
			})[0];

			if (options.filter(function (option) {
				return option._asEmpty;
			}).length == 0) {
				options.unshift({ formattedvalue: this.props.placeholder || '- Select ' + this.props.label + ' -', id: "", _asEmpty: true });
				if (!theSelectedOption) {
					theSelectedOption = options[0];
				}
			}

			return React.createElement(
				'label',
				{ hidden: this.options().length == 0 },
				React.createElement(
					'span',
					{ className: this.props.labelOutside ? '' : 'sr-only' },
					this.props.label
				),
				/* This isn't actually a button, it's just there for presentation. */null,
				React.createElement(
					'button',
					{ 'data-dropdown-toggle': true, tabIndex: '-1' },
					React.createElement(
						'span',
						{ className: theSelectedOption._asEmpty ? 'placeholder' : '' },
						!this.props.labelOutside && theSelectedOption._asEmpty ? this.props.label : theSelectedOption.formattedvalue || theSelectedOption.value
					)
				),
				React.createElement(
					'select',
					{ size: '1', onChange: function onChange(event) {
							return _this2.updateValue(_this2.options().filter(function (item) {
								return item.id == event.target.value;
							})[0] || null, true);
						}, value: theSelectedOption.id },
					this.getOptionList(options)
				),
				this.additionalContent()
			);
		}
	}, {
		key: 'updateValue',
		value: function updateValue(value, commitNow) {
			if (value) {
				if (value._asEmpty) value = null;
			}
			_get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'updateValue', this).call(this, value, commitNow);
		}
	}, {
		key: 'commitValue',
		value: function commitValue(value) {
			if (value) {
				if (value._asEmpty) value = null;
			}
			_get(ListBox.prototype.__proto__ || Object.getPrototypeOf(ListBox.prototype), 'commitValue', this).call(this, value);
		}
	}, {
		key: 'defaultValue',
		get: function get() {
			return null;
		}
	}]);

	return ListBox;
}(_base2.default);

exports.default = ListBox;